import type { IPoint } from '@fluentui/react/lib/Utilities';
import type { FolderForestNodeType } from 'owa-favorites-types';
import { mutatorAction } from 'satcheljs';
import type { FolderContextMenuState } from 'owa-mail-folder-store/lib/store/schema/FolderContextMenuState';
import { getStore as getSharedFavoritesStore } from 'owa-favorites';
import getMailFavoritesViewState from '../selectors/getMailFavoritesViewState';
import { getAccountKeyForMailboxInfo, type AccountKey } from 'owa-client-types';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { getStore } from '../store/store';
import { isMonarchMultipleAccountsEnabled } from 'owa-account-source-list';

/*
 * Sets state to spawn a context menu attached to a favorite node.
 */
export function showFavoritesContextMenu(
    nodeId: string,
    nodeType: FolderForestNodeType,
    anchor: IPoint,
    folderId?: string,
    showRootMenu?: boolean,
    isPlaceholderNode?: boolean
): void {
    const mailboxInfo = isMonarchMultipleAccountsEnabled()
        ? getGlobalSettingsAccountMailboxInfo()
        : getSharedFavoritesStore().outlookFavorites?.get(nodeId)?.mailboxInfo ??
          getModuleContextMailboxInfo();
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    if (!accountKey) {
        return;
    }

    setContextMenuState(accountKey, {
        nodeId,
        nodeType,
        folderId,
        anchor,
        treeType: 'favorites',
        showRootMenu,
        isPlaceholderNode,
    });
}

/* eslint-disable-next-line owa-custom-rules/require-add-identifier-to-mutator-action-variables -- (https://aka.ms/OWALintWiki)
 * Mutator action variables should end with 'Mutator' so that we can more easily identify potential misuses of it.
 *	> Please add 'Mutator' substring add the end of the mutator action variable name. */
export const setContextMenuState: (
    accountKey: AccountKey,
    state: FolderContextMenuState | null
) => void = mutatorAction(
    'setContextMenuState',
    (accountKey: AccountKey, state: FolderContextMenuState | null): void => {
        const mailFavoritesViewState = getMailFavoritesViewState(accountKey);
        if (mailFavoritesViewState) {
            mailFavoritesViewState.contextMenuState = state;
        } else {
            getStore().mailFavoritesViewState.set(accountKey, {
                contextMenuState: state,
                shouldShowFindFavoritesPicker: false,
            });
        }
    }
);
